import { mainColor } from "shared/colors";

export const pageTitleStyle = {
  titleStyle: {
    textTransform: "uppercase",
    fontWeight: 600,
    color: mainColor,
  },
};
